import { all, takeLatest, call, put } from "redux-saga/effects";
import { getDashboardStats } from "services/apis/dashboard";
import actions from "./actions";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* STATS({ payload }) {
  const silent = payload && payload.silent;

  if (!silent) {
    yield loading(true);
  }

  const response = yield call(getDashboardStats, payload);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        stats: response,
      },
    });
  }
  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.STATS, STATS)]);
}
